/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import { ChangeRequestRequestedReviewer, JSONDocument, List } from "./data-contracts";

/**
 * No description
 * @tags change-request-reviewers
 * @name GetRequestedReviewersByChangeRequestId
 * @summary Get all change request reviewers
 * @request GET:/spaces/{spaceId}/change-requests/{changeRequestId}/requested-reviewers
 * @secure
 */

// @ts-ignore
export const getRequestedReviewersByChangeRequestId: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
    /** The unique ID of the change request or its number identifier in the space */
    changeRequestId: string;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: ChangeRequestRequestedReviewer[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/change-requests/{changeRequestId}/requested-reviewers",
  method: "get",
  streaming: false,
  tags: ["change-request-reviewers"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags change-request-reviewers
 * @name RequestReviewersForChangeRequest
 * @summary Request change request reviewers
 * @request POST:/spaces/{spaceId}/change-requests/{changeRequestId}/requested-reviewers
 * @secure
 */

// @ts-ignore
export const requestReviewersForChangeRequest: {
  route: string;
  method: "post";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
    /** The unique ID of the change request or its number identifier in the space */
    changeRequestId: string;
  };
  RequestQuery: {};
  RequestBody: {
    /** An array of user ids that will be requested. */
    users: string[];
    /** Optionally, update the subject of the change request when requesting reviewers. */
    subject?: string;
    /** Optionally, update the description of the change request when requesting reviewers. */
    description?: JSONDocument;
  };
  RequestHeaders: {};
  ResponseBody: {
    /** The user requests that were sent. */
    users?: ChangeRequestRequestedReviewer[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/change-requests/{changeRequestId}/requested-reviewers",
  method: "post",
  streaming: false,
  tags: ["change-request-reviewers"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags change-request-reviewers
 * @name RemoveRequestedReviewerFromChangeRequest
 * @summary Remove a reviewer from a change request
 * @request DELETE:/spaces/{spaceId}/change-requests/{changeRequestId}/requested-reviewers/{userId}
 * @secure
 */

// @ts-ignore
export const removeRequestedReviewerFromChangeRequest: {
  route: string;
  method: "delete";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
    /** The unique ID of the change request or its number identifier in the space */
    changeRequestId: string;
    /** The unique ID of the User */
    userId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 205;
} = {
  route: "/spaces/{spaceId}/change-requests/{changeRequestId}/requested-reviewers/{userId}",
  method: "delete",
  streaming: false,
  tags: ["change-request-reviewers"],
  criticalityLevel: "low",
  deprecated: false,
};
